import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/i18n'
import CacheBuster from './components/shared/CacheBuster.tsx'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CacheBuster>
      {({ loading }) => {
        if (loading) return null
        return <App />
      }}
    </CacheBuster>
  </StrictMode>,
)
